import React from //useState,
//useEffect,
//useMemo,
'react';

// import {
// 	useSelector,
// 	useDispatch
// } from 'react-redux';

import { GenericListSelect } from './genericListSelect.js';

export const AnimalAgeSelect = (props) => {
	let types = [
		'Calves',
		'Weaners',
		'Yearlings',
		'Young Adults',
		'Mature Adults',
	];

	if (props.species === 'Sheep') {
		types = ['0.5', '1', '2', '3+'];
	}

	return (
		<>
			<GenericListSelect
				id="Age"
				label="Age"
				dataArray={types}
				cols={props.cols}
				controlStyle={props.controlStyle}
				handleChange={(evt) => props.handleChange(evt)}
				value={props.value}
				required={props.required}
				//pattern = {'^\d+$'}	// integer
				pattern={'^[a-zA-Z]+[a-zA-Z]+$'}
				invalidMsg="Select Animal age!"
				lock={props.lock}
			/>
		</>
	);
};
